import RecurrenceBlock from './RecurrenceBlock';

export default RecurrenceBlock;
